:root {
  --easing: cubic-bezier(0.16, 1, 0.3, 1);
}

chapel-event {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  background-color: white;
  border-radius: 0.5rem;
  outline: 1px solid rgba(0,0,0,0.1);
  overflow: hidden;
  text-align: left;
}

chapel-event > div {
  display: flex;
  padding: 1rem;
}

chapel-event > div:not(:last-child) {
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

chapel-event > div *:not(:last-child) {
  margin-right: 1rem;
}

chapel-event img {
  width: 32px;
  height: 32px;
}

chapel-event .chapel-event-sharing-calendars::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.05);
}

chapel-event .chapel-event-sharing {
  display: flex;
  padding: 0;
}

chapel-event .chapel-event-sharing img {
  width: 20px;
  height: 20px;
}

chapel-event .chapel-event-sharing > * {
  position: relative;
  display: flex;
  padding: 1rem 1rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  user-select: none;
  overflow: hidden;
}

chapel-event .chapel-event-sharing > * > * {
  opacity: 0;
  animation: 300ms animate--appear var(--easing) forwards;
}

chapel-event .chapel-event-sharing * > *:not(:last-child) {
  margin-right: 0.5rem;
}

@keyframes animate--appear {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

chapel-event .chapel-event-sharing > *:not(:last-child) {
  margin-right: 0;
  border-right: 1px solid rgba(0,0,0,0.1);
}

chapel-event .chapel-event-sharing * {
  position: relative;
}

chapel-event .chapel-event-sharing > *::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  transition: background-color 200ms ease-in;
}

chapel-event .chapel-event-sharing > *:hover::before {
  background-color: rgba(0,0,0,0.05);
}

@media (max-width: 360px) {
  chapel-event .chapel-event-sharing > * {
    flex-direction: column;
  }

  chapel-event .chapel-event-sharing *:not(:last-child) {
    margin-right: 0;
  }

  chapel-event .chapel-event-sharing * > *:not(:last-child) {
    margin-bottom: 0.4rem;
  }
}


loadable-image img {
  opacity: 0;
  transition: 500ms ease-in;
  vertical-align: middle;
}

loadable-image img.image-is-loaded {
  opacity: 1;
}

